//TODO remove the file once globs removed

import './_controllers/member_bookings.controller.js';
import './_controllers/wallet.controller.js';
import './_models/member_booking_model.service.js';
import './_models/member_member_model.service.js';
import './_models/member_payment_item_model.service.js';
import './_models/member_pre_paid_booking_model.service.js';
import './_models/member_purchase_item_model.service.js';
import './_models/member_purchase_model.service.js';
import './_models/member_wallet_log_model.service.js';
import './_models/member_wallet_model.service.js';
import './_models/member_wallet_purchase_band_model.service.js';
import './_services/member_bookings.service.js';
import './_services/member_login.service.js';
import './_services/member_options.provider.js';
import './_services/member_pre_paid_bookings.service.js';
import './_services/member_purchase.service.js';
import './_services/member.service.js';
import './_services/service_payment_item.service.js';
import './_services/wallet.service.js';
import './_translations/en.js';
import './entry.module.js';
import './globs_to_remove.js';
import './logged-user/logged_user.directive.js';
import './login-member/login_member.controller.js';
import './login-member/login_member.directive.js';
import './login-member/pick_company.controller.js';
import './login/login.directive.js';
import './main.config.js';
import './main.module.js';
import './main.run.js';
import './member-booking/member_booking.directive.js';
import './member-bookings-table/member_bookings_table.directive.js';
import './member-bookings/member_bookings.directive.js';
import './member-form/member_form.directive.js';
import './member-login/member_login.directive.js';
import './member-past-bookings/member_past_bookings.directive.js';
import './member-pre-paid-bookings/member_pre_paid_bookings.directive.js';
import './member-purchases/member_purchases.directive.js';
import './member-sso-login/member_sso_login.directive.js';
import './member-upcoming-bookings/member_upcoming_bookings.directive.js';
import './membership-levels/membership_levels.directive.js';
import './wallet-logs/wallet_logs.directive.js';
import './wallet-payment/wallet_payment.directive.js';
import './wallet-purchase-bands/wallet_purchase_bands.directive.js';
import './wallet-remainder/wallet_remainder.directive.js';
import './wallet/wallet.directive.js';


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/member/globs_to_remove.js